import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { PICFLOW_CONFIG } from '../../../picflow-config';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';
import { ObservableDataLoaderService } from '../../../services/observable-data-loader.service';

@Component({
  selector: 'app-animated-svg',
  template: `<div [innerHTML]="svg() | safeHtml"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SafeHtmlPipe],
})
export class AnimatedSvgComponent {
  private http = inject(HttpClient);
  private loader = inject(ObservableDataLoaderService);
  src = input.required<string>();
  alt = input<string>();
  href = computed(() => {
    const src = this.src();
    if (!this.config.useAbsoluteUrls) return src;
    return this.config.correctPicflowUrl + src;
  });
  private config = inject(PICFLOW_CONFIG);

  svg = signal('');

  constructor() {
    effect(
      () => {
        const src = this.src();
        return this.loader
          .get(`svg-${src}`, () => this.http.get(src, { responseType: 'text' }))
          .subscribe(svg => {
            this.svg.set(svg);
          });
      },
      { allowSignalWrites: true }
    );
  }
}
